import { useEffect, useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { EASE, SHOW_INTRO } from "../../lib/api";

export const Preloader = () => {
  const [show, setShow] = useState(SHOW_INTRO);
  useEffect(() => {
    if (!show) return undefined;
    const t = setTimeout(() => { setShow(false); sessionStorage.setItem("mk-intro", "1"); }, 1700);
    return () => clearTimeout(t);
  }, [show]);

  return (
    <AnimatePresence>
      {show && (
        <motion.div
          key="pre"
          data-testid="preloader"
          className="fixed inset-0 z-[100] flex flex-col items-center justify-center gap-6 bg-night text-ivory"
          exit={{ clipPath: "inset(0 0 100% 0)" }}
          initial={{ clipPath: "inset(0 0 0% 0)" }}
          transition={{ duration: 1, ease: EASE }}
        >
          <motion.img src="/img/emblem.png" alt="" className="h-24 w-24"
            initial={{ rotateY: 180, scale: 0.6, opacity: 0 }} animate={{ rotateY: 0, scale: 1, opacity: 1 }} transition={{ duration: 1.2, ease: EASE }} />
          <motion.p className="font-display text-2xl uppercase" initial={{ letterSpacing: "0.1em", opacity: 0 }} animate={{ letterSpacing: "0.6em", opacity: 1 }}
            transition={{ duration: 1.4, ease: EASE, delay: 0.15 }}>Markhor</motion.p>
        </motion.div>
      )}
    </AnimatePresence>
  );
};
